<template>
	<div class="fc-edit-detail">
		<label>Edit Details</label>
		<form>
			<div>
				<label><span>*</span>FULL NAME</label>
				<input v-model="account.FullName" type="text" />
			</div>
			<div>
				<label><span>*</span>EMAIL</label>
				<input v-model="account.Email" type="text" />
			</div>
			<div>
				<label><span>*</span>MOBILE NO.</label>
				<input v-model="account.ContacctNo" type="text" />
			</div>
			<div>
				<a @click="editCustomer">UPDATE DETAILS</a>
			</div>
		</form>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'editprofile',
  data () {
    return {
      account: {
        FullName: '',
        Email: '',
        ContacctNo: ''
      }
    }
  },
  created () {
    this.account = {
      FullName: this.info.FullName,
      Email: this.info.Email,
      ContacctNo: this.info.ContacctNo
    }
  },
  methods: {
    editCustomer () {
      const profile = JSON.parse(JSON.stringify(this.account))
      this.$store.dispatch('customer/editCustomerInfo', profile)
        .then(a => {
          this.$emit('closeEditDetail')
        })
    }
  },
  computed: {
    ...mapGetters('customer', ['info'])
  }
}
</script>


// WEBPACK FOOTER //
// src/components/profile/EditDetail.vue